import Switch, { switchClasses } from "@mui/joy/Switch";

const SwtichButton = ({ checked, onChange }) => {
  return (
    <Switch
      color={checked ? "success" : "danger"}
      checked={checked}
      onChange={onChange}
      sx={{
        "--Switch-thumbSize": "13px",
        "--Switch-trackWidth": "34px",
        "--Switch-trackHeight": "20px",
        "--Switch-trackBackground": "#EE5E52",
        "&:hover": {
          "--Switch-trackBackground": "#EE5E52",
        },
        [`&.${switchClasses.checked}`]: {
          "--Switch-trackBackground": "#5CB176",
          "&:hover": {
            "--Switch-trackBackground": "#5CB176",
          },
        },
      }}
    />
  );
};

export default SwtichButton;
